module.exports = __webpack_public_path__ + "static/img/second_image.99e6b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/second_image.png
// module id = 563
// module chunks = 1